import type { ReactNode } from 'react';
import { DeviceAppVersionCard } from '../device-app-version-card/DeviceAppVersionCard.ctrl';
import { DeviceAppVersionFilesList } from '../device-app-version-files-list/DeviceAppVersionFilesList.ctrl';
import { DeviceAppVersionUploadSummary } from '../device-app-version-upload-summary/DeviceAppVersionUploadSummary';
import type { DeviceAppVersionSummaryFileListCardProps } from './deviceAppVersionSummaryFileListCard.model';

export function DeviceAppVersionSummaryFileListCard({
  title,
  sumUnitFile,
  mainFiles,
  secondaryFiles,
  chipInfo,
  isLoadingMain,
  isLoadingSecondary,
}: DeviceAppVersionSummaryFileListCardProps): ReactNode {
  return (
    <DeviceAppVersionCard chipInfo={chipInfo} title={title}>
      {secondaryFiles?.length ? (
        <div>
          <DeviceAppVersionFilesList isLoading={isLoadingSecondary} items={secondaryFiles} readOnly />
        </div>
      ) : undefined}
      <div>
        <DeviceAppVersionFilesList isLoading={isLoadingMain} items={mainFiles} readOnly />
        <DeviceAppVersionUploadSummary hideAddButton size={sumUnitFile} />
      </div>
    </DeviceAppVersionCard>
  );
}
